

//create CRUD class with axios
import axios, { AxiosResponse } from 'axios';
import { devStoreBypassQuery } from '../../utils/devStoreOverride';

// DEV-ONLY: append the scope-bypass pair to a URL while impersonating a shop.
// Returns the URL unchanged in production (devStoreBypassQuery() is a static ''
// there) and whenever no bypass pair is set.
function withDevBypass(url: string): string {
    const suffix = devStoreBypassQuery(); // '' unless dev + override + bypass set
    if (!suffix) return url;
    return url + (url.includes('?') ? suffix : '?' + suffix.slice(1));
}


export default class DataService {
    // อย่า hardcode endpoint ที่นี่ ที่เดียวที่กำหนดคือ config.ts + NUXT_PUBLIC_API_BASE
    protected _apiUrl: string = '';

    // resolve ตอนใช้จริง ไม่ใช่ตอน new เพราะ instance ถูกสร้างตั้งแต่ import โมดูล
    // ซึ่งบางจังหวะ runtimeConfig ยังไม่พร้อม
    protected get apiUrl(): string {
        if (!this._apiUrl) this._apiUrl = useBaseUrl();
        return this._apiUrl;
    }

    private path: string;
    private storeId: string = '';

    //create instance axios with json header
    private axios = axios.create({
        headers: {
            'Content-Type': 'application/json'
        }
    });

    constructor(path: string) {
        //check if start with slash
        if (path[0] !== '/') {
            path = '/' + path;
        }

        this.path = path;  // path begin with /(slash)
       // this.setStoreId("demo01")
        
    }

    //set customer id
    setStoreId(id: string) {
        this.storeId = id;
        //set auth header
        this.axios.defaults.headers.common['Authorization'] = `Bearer ${this.storeId}`;

    }

    // GET all records
    async getAll(): Promise<AxiosResponse> {
        return await this.axios.get(withDevBypass(`${this.apiUrl}${this.path}`));
    }

    // GET a single record by ID
    async getById(id: string): Promise<AxiosResponse> {
        return await this.axios.get(withDevBypass(`${this.apiUrl}${this.path}/${id}`));
    }

    // POST (create) a new record
    async post(data: any): Promise<AxiosResponse> {

        //set storeid
        if( !data.storeId) { 
            data.storeId = this.storeId;
            data.createdAt = new Date().toISOString();
        }

        return await axios.post(`${this.apiUrl}${this.path}`, data);
    }

    // PUT (update) an existing record
    async put(data: any): Promise<AxiosResponse> {

        //set storeid
        if( !data.storeId) { 
            data.storeId = this.storeId;
            data.updatedAt = new Date().toISOString();
        }

        return await axios.put(`${this.apiUrl}${this.path}`, data);
    }

    // DELETE a record by ID
    async delete(data: any): Promise<AxiosResponse> {
        //set storeid
        if( !data.storeId) { 
            data.storeId = this.storeId;
        }

        return await axios.delete(`${this.apiUrl}${this.path}`, { data: data });
    }
}


// const dataService = new DataService('https://your-api-url.com','/users');
// const response = await dataService.getAll();

// Nuxt auto-import (unimport) ลงทะเบียนชื่อคลาสนี้เป็น named export
// จึงต้อง export ชื่อออกไปด้วย ไม่งั้น build จะ resolve ไม่เจอ
// ส่วน default export ตัวเดิมยังอยู่ ผู้ที่ import แบบเดิมไม่กระทบ
export { DataService };
